import axios from 'axios'
import React, { useRef } from 'react'
import { useState } from 'react'

import { Link } from 'react-router-dom'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'



import {HiEllipsisHorizontal} from 'react-icons/hi2'

import { FaShare,FaComment} from 'react-icons/fa'

import profile from '../img/untitled.png'
import post1 from '../img/post1.jpg'
import post3 from '../img/post3.png'
import ad1 from '../img/adCheckout1.jpg'
import ad2 from '../img/adCheckout2.jpg'
import ad3 from '../img/adCheckout3.jpg'
import { AiOutlineHeart, AiOutlineLeft, AiOutlineRetweet, AiOutlineRight } from 'react-icons/ai'
import MyModal from './PostModal'
import CreatePostImg from './CreatePostImg'
import CreateQuotePost from './CreateQuotePost'
import CreateLinkPost from './CreateLinkPost'
import CreateHiChatPost from './CreateHiChatPost'
import CreateAudioPost from './CreateAudioPost'
import CreateVidPost from './CreateVidPost'
import { GrDocumentExcel } from 'react-icons/gr'
import { IoIosArrowForward } from 'react-icons/io'

export default function Profile () {
  const [showTooltip,setShowTooltip]=useState(false)
  const [showCommentTooltip,setShowCommentTooltip] =useState(false)
  const newPostRef= useRef(null)
  const div= newPostRef.current
  const HandleScrollToRight=()=>{
if(div){
  
const scrolltoRightEnd=div.scrollWidth-div.clientWidth;
div.scrollLeft=scrolltoRightEnd
}
  }


  const HandleScrollToLeft=()=>{
    if(div){
      
    const scrolltoLeftEnd=div.scrollWidth+div.clientWidth;
    div.scrollLeft=0
    }
      }
   
  return (
   <>
   <div className="row container-fluid ">
    <div className="col-lg-6 col-md-12 col-sm-12">
    <main className='mt-5 pt-5 header'>

<section className=' d-flex text-center justify-content-center col-lg-12 col-sm-12 '>
<div className="profile me-2  ">
<img src={profile} alt="" className='rounded-2' />
</div>

<div className='createPost bg-white container rounded-1 p-1 pe-5 col-lg-10 col-sm-12 col-md-10' >



<ul className='d-lg-flex d-sm-flex d-md-flex list-style-none justify-content-between' ref={newPostRef} >

<li>
<MyModal


  
/>

<Link className='post text-dark text-decoration-none'>

</Link>
</li>

<li>
<CreatePostImg/>

</li>

<li>
<CreateQuotePost/>
  
</li>

<li >

  <CreateLinkPost/>
</li>



<li>
<CreateHiChatPost/>
 
 
</li>

<li>
<CreateAudioPost/>
  
</li>

<li>
<CreateVidPost/>
 
 </li>

</ul>

<div className='btnContainer container-fluid'>


<Link className=' btnLeft me-5 me-auto '
onClick={HandleScrollToLeft}

> <AiOutlineLeft/></Link>

<Link className='btnRight '
onClick={HandleScrollToRight}
> <AiOutlineRight/></Link>
</div>


</div>
</section>





<section className='  text-center justify-content-center col-lg-12 col-sm-12 col-lg-10 mt-2 p-6 '>


<div className='post bg-white ms-auto opacity-25 rounded-1 p-5  pe-1 me-3 col-md-10 col-sm-12 col-lg-10'>



<main className='p-5' >
<p className='fs-1 text-white ' style={{color:"rgb(255,255,255,0.65)"}}><GrDocumentExcel/></p>
<p className='text-dark fw-bolder fs-4 ' >No Post Available</p>
</main>

</div>
</section>








</main>
  </div>

  <div className="col-lg-4 text-start ">
  <header className='  text-light mt-5 pt-5'>
    <p className='fs-6 fw-bolder'>Centeeeee</p>
  </header>

  <section className=' mt-2 profileList'>
    <ul>
    <Link className='text-decoration-none'>
      <li className='  text-light'>
      
     
      Posts
     
  
      </li>
      </Link>
    
    
      <Link className='text-decoration-none'>
      <li className=''>
      
      
      Followers
    
  
      </li>
      </Link>

      <Link className='text-decoration-none'>
      <li className=''>
      
      
      Activity
    
  
      </li>
      </Link>


      <Link className='text-decoration-none'>
      <li className=''>
      
      
      Drafts



  
      </li>
      </Link>


      <Link className='text-decoration-none'>
      <li className=''>
      
      
      Queue
    
  
      </li>
      </Link>


      <Link className='text-decoration-none'>
      <li className=''>
      
      
      Tumblr Blaze
    
  
      </li>
      </Link>


      <Link className='text-decoration-none'>
      <li className=''>
      
      
      Gifts
    
  
      </li>
      </Link>



      <Link className='text-decoration-none '>
      <li className='d-flex justify-content-between'>
      
      
      Edit Appearance <span className='ms-auto'> <IoIosArrowForward/> </span>
    
  
      </li>
      </Link>

      <Link className='text-decoration-none '>
      <li className='d-flex justify-content-between'>
      
      
      Mass Post Editor <span className='ms-auto'> <IoIosArrowForward/> </span>
    
  
      </li>
      </Link>




     

      
    </ul>
  </section>
</div>
    </div>



   </>
  )
}
